import React from "react";
import proyects from "../../api/projects-cluster";
import { useNavigate } from "react-router-dom";

const ProjectClusterHorizontalList = () => {
  const navigate = useNavigate();

  return (
    <>
    <h2 className="project-cluster-horizontal-list__title">Visitar otros proyectos</h2>
    <div  className="project-cluster-horizontal-list__decoration" >
        <div  className="project-cluster-horizontal-list__short1"></div>
        <div className="project-cluster-horizontal-list__short2"></div>
    </div>
    <div className="project-cluster-horizontal-list">
        
      {proyects.map((project) => (
        <div
          className="project-cluster-card"
          key={project.id}
          onClick={() => navigate(project.proyectLink)}
        >
          <img
            src={project.screens}
            alt={project.title}
            className="project-cluster-card__img"
          />
          <div className="project-cluster-card__info">
            <div className="project-cluster-card__title">{project.title}</div>
            <div className="project-cluster-card__date">{project.create_at}</div>
          </div>
        </div>
      ))}
    </div>
    </>
)};

export default ProjectClusterHorizontalList;
